const DEFAULT_MAX_CAPTURED_AMOUNT = 10;
const AMMEN_LIFE_STAGE_DAYS = 115;
const CHUNK_SIZE_TO_DISPLAY = 70;
const DEFAULT_LANGUAGE = "de";

export { DEFAULT_LANGUAGE, DEFAULT_MAX_CAPTURED_AMOUNT, AMMEN_LIFE_STAGE_DAYS, CHUNK_SIZE_TO_DISPLAY };
